import styled from '@emotion/styled';

export const Wrapper = styled.main`
  display: flex;
  width: 100vw;
  height: 100vh;
  align-items: center;
  flex-direction: column;
  padding-top: 80px;
`;

export const MainGuide = styled.p`
  margin-top: 30px;
  margin-bottom: 24px;
  font-size: 20px;
  line-height: 24px;
  // color: ${({ theme }) => theme.colors.neutral[700]};
  font-weight: 700;
`;

export const SubGuide = styled.p`
  white-space: pre-line;
  text-align: center;정
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
`;
